import React from "react";

// Styles
import QualityMatrixViewContainer from "./QualityMatrixView.styles";
import PowerBIDashboard from "../../../../components/Common/PowerBIDashboard";

interface QualityMatrixViewProps {}

const QualityMatrixView = ({}: QualityMatrixViewProps) => {
    return (
        <QualityMatrixViewContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="e5fc799a-c36f-49bb-aad6-4fa690fcfcbd"
                    workspaceId="c9679fac-e043-4b12-b47b-d350f81543c1"
                ></PowerBIDashboard>
            </div>
        </QualityMatrixViewContainer>
    );
};
export default QualityMatrixView;
